import { SispacError } from './sispac-error';

export class UnknownUrlError extends SispacError { }



// WEBPACK FOOTER //
// ./src/app/components/shared/errors/unknown-url-error.ts